class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById('cart-drawer');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.debouncedUpdateCartNote = debounce((event) => {
      this.updateCartNote(event.target.value);
    }, 300);

    document.addEventListener('click', (e) => {
      const button = document.querySelector('#cart-drawer .cart-close');
      if (e.target == button) {
        this.close.call(this);
      }
    });

    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('cart-drawer-quantity-input')) {
        this.onChange(e);
      }
    });

    document.addEventListener('click', (e) => {
      const button = document.querySelector('#cart-drawer .cart-drawer-gift-wrap button');

      if (e.target == button) {
        e.preventDefault();
        this.addItem(button.dataset.variantId, { _gift_wrap: true });
      }
    });

    document.addEventListener('click', (e) => {
      const button = document.querySelector('#gift_wrap_remove');

      if (e.target == button) {
        e.preventDefault();
        this.updateQuantity(button.dataset.line, 0).then(() => this.updateCartNote(''));
      }
    });

    document.addEventListener('keyup', (e) => {
      const giftNote = document.getElementById('gift_wrap_note');

      if (e.target == giftNote) {
        this.debouncedUpdateCartNote(e);
      }
    });

    document.addEventListener('click', (e) => {
      const button = document.querySelector('.cart-drawer-upsell-item-add');

      if (e.target == button) {
        e.preventDefault();
        const id = document.getElementById('cart_upsell_select').value;
        this.addItem(id);
      }
    });
  }

  open() {
    this.drawer.classList.add('animate', 'active');
    document.querySelector('body').classList.add('modal-open');

    this.drawer.addEventListener(
      'transitionend',
      () => {
        this.drawer.focus();
        trapFocus(this.drawer);
      },
      { once: true }
    );

    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClick);
    }, 0);
  }

  close() {
    this.drawer.classList.remove('active');
    document.querySelector('body').classList.remove('modal-open');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }

  enableLoading() {
    this.drawer.classList.add('loading');
  }

  disableLoading() {
    this.drawer.classList.remove('loading');
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  updateQuantity(line, quantity) {
    this.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: ['cart-drawer'],
      sections_url: window.location.pathname,
    });

    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.json();
    })
    .then((state) => {
      this.renderContents(state);
      this.disableLoading();
    })
    .catch((e) => {
      this.disableLoading();
    });
    affirm.ui.refresh();
  }

  addItem(variantId, properties) {
    this.enableLoading();

    let item = {
      quantity: 1,
      id: variantId,
    };

    if (properties) item.properties = properties;

    const body = JSON.stringify({
      items: [item],
      sections: ['cart-drawer'],
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((state) => {
        this.renderContents(state);
      })
      .catch(console.error)
      .finally(() => {
               this.disableLoading();
    });

    affirm.ui.refresh();

  }

  updateCartNote(note) {
    const body = JSON.stringify({ note });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    document.getElementById('cart-drawer').innerHTML = this.getSectionInnerHTML(
      parsedState.sections['cart-drawer'],
      '#cart-drawer'
    );
    affirm.ui.refresh();
    this.updateCartCountBubble();
    this.open();
  }

  updateCartCountBubble() {
    fetch(`${routes.cart_url}`, { ...fetchConfig() })
      .then((response) => response.json())
      .then((cart) => {
        document.querySelector('.header-actions__cart-count').innerHTML = cart.item_count || '';
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);
